
import { Component, Vue, Prop } from 'vue-property-decorator';

import { IParam } from 'server/src/ai/interface/IParam';
import { DragManager, typeMoveBot, typeSelectBot, typeMoveParam, typeMoveObj } from "./DragManager";

@Component
export default class ObjectTable extends Vue {
  // Define a prop to pass the list of objects to the component
  @Prop({ required: true }) private _lista!: Array<object>;
    dm=DragManager.getInstance()
  lista:any[]=[]
  async mounted() {
    this.lista=this._lista
  }


  none(event:MouseEvent) {
    event.stopPropagation();
    event.preventDefault();
  }

  copyToNotepad(value:string, event:MouseEvent) {
    event.stopPropagation()
    event.preventDefault()

    let valueToCopy = JSON.stringify(value);
    valueToCopy =  valueToCopy.replace(/\\n/g, '\n');
    valueToCopy = valueToCopy.replace(/\\"/g, '"');

    // Create a temporary textarea element to facilitate copying to clipboard
    const textarea = document.createElement('textarea');
    textarea.value = valueToCopy;
    document.body.appendChild(textarea);

    // Select the value within the textarea
    textarea.select();
    textarea.setSelectionRange(0, 99999); // For mobile devices

    // Copy the selected text to clipboard
    document.execCommand('copy');

    // Remove the temporary textarea
    document.body.removeChild(textarea);

  
  }


  async handleDragStart(obj: any, key:string, event:MouseEvent) {
    
    event.stopPropagation();
    event.preventDefault();
    this.dm.reset(typeMoveBot)
    this.dm.reset(typeMoveParam)
    this.dm.reset(typeMoveObj)
    
    console.log(" ObjectTable", key, obj[key])
    const o:any  = { key: key, value:obj[key]}
    console.log(o)
    this.dm.set(o, typeMoveObj)
    this.dm.show_tooltip(key+':'+obj[key], event.clientX-10, event.clientY+10 )
    this.copyToNotepad(obj[key], event)
  }

  async dragEnd() { alert("Nie możesz tu upuścić danych!") }

}


